/**
 * La marca de CADA residencial.
 *
 * El nombre estaba escrito a mano en cinco sitios («Villa Primavera») y en el
 * SMS del backend. Con varias residenciales eso significa que el residente de
 * una vería el nombre de otra, que es la primera cosa que nota un cliente y
 * la que más desconfianza genera.
 *
 * Ahora sale de la sesión: el servidor manda el nombre, el logo y el color al
 * iniciar sesión. Mientras nadie ha entrado —la pantalla de acceso— se usa un
 * nombre genérico, porque en ese momento el sistema todavía no sabe quién es.
 */

export const MARCA_GENERICA = {
  name: "Control Residencial",
  tagline: "Acceso seguro para su comunidad",
  logoUrl: null,
  primaryColor: null,
};

/** Iniciales para el logo cuando la residencial no subió imagen. */
export const inicialesDe = (nombre) =>
  String(nombre || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join("")
    .toUpperCase() || "CR";

/** La marca de la sesión actual, con respaldo genérico. */
export const marcaDe = (usuario) => {
  const r = usuario?.residential;
  if (!r?.name) return MARCA_GENERICA;
  return {
    name: r.name,
    tagline: MARCA_GENERICA.tagline,
    logoUrl: r.logoUrl || null,
    primaryColor: r.primaryColor || null,
  };
};
